<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Kas Eksternal</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2"><v-text-field v-model="form.tanggal" type="date" label="Tanggal *" dense /></v-col>
          <v-col cols="12" md="2"><v-select v-model="form.arah" :items="arahOptions" label="Arah *" dense /></v-col>
          <v-col cols="12" md="2"><v-select v-model="form.jenis" :items="['masuk','keluar']" label="Jenis *" dense /></v-col>
          <v-col cols="12" md="2"><v-text-field v-model="form.kategori" label="Kategori" dense /></v-col>
          <v-col cols="12" md="2"><v-text-field v-model.number="form.nominal" type="number" label="Nominal *" dense /></v-col>
          <v-col cols="12" md="2"><v-text-field v-model="form.keterangan" label="Keterangan *" dense /></v-col>
          <v-col cols="12" class="text-right"><v-btn text @click="reset">Batal</v-btn><v-btn color="primary" :loading="loading" @click="save">{{ form.id ? "Update" : "Simpan" }}</v-btn></v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table class="mt-4" :headers="headers" :items="items" dense>
      <template v-slot:item.arah="{item}">{{ arahLabel(item.arah) }}</template>
      <template v-slot:item.nominal="{item}">Rp {{ money(item.nominal) }}</template>
      <template v-slot:item.actions="{item}"><v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon><v-icon small color="error" @click="remove(item)">mdi-delete</v-icon></template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
export default {
  name: "KasExternal",
  data() {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const arah = user.lokasi === "pontianak" ? "pontianak_jakarta" : user.lokasi === "jakarta" ? "jakarta_pontianak" : "declaring";
    return {
      user, items: [], loading: false,
      form: { id: null, tanggal: today(), arah, jenis: "keluar", kategori: "", keterangan: "", nominal: 0 },
      arahOptions: [{text:"Pontianak → Jakarta",value:"pontianak_jakarta"},{text:"Jakarta → Pontianak",value:"jakarta_pontianak"},{text:"Declaring",value:"declaring"}],
      headers: [{text:"Tanggal",value:"tanggal"},{text:"Arah",value:"arah"},{text:"Jenis",value:"jenis"},{text:"Kategori",value:"kategori"},{text:"Keterangan",value:"keterangan"},{text:"Nominal",value:"nominal"},{text:"Dibuat Oleh",value:"pembuat.nama"},{text:"Aksi",value:"actions",sortable:false}]
    };
  },
  created() { this.fetchData(); },
  methods: {
    money(v) { return Number(v || 0).toLocaleString("id-ID"); },
    arahLabel(v) { return (this.arahOptions.find(x => x.value === v) || {}).text || v; },
    async fetchData() { try { this.items = (await axios.get("kas-external")).data; } catch(e) { alert(e.response?.data?.message || "Gagal memuat kas eksternal"); } },
    async save() {
      this.loading = true;
      try { this.form.id ? await axios.put(`kas-external/${this.form.id}`, this.form) : await axios.post("kas-external", this.form); this.reset(); this.fetchData(); }
      catch(e) { alert(e.response?.data?.message || "Gagal menyimpan transaksi"); }
      finally { this.loading = false; }
    },
    edit(item) { this.form = { ...item }; },
    async remove(item) { if (confirm("Hapus transaksi ini?")) { try { await axios.delete(`kas-external/${item.id}`); this.fetchData(); } catch(e) { alert(e.response?.data?.message || "Gagal menghapus"); } } },
    reset() {
      const arah = this.user.lokasi === "pontianak" ? "pontianak_jakarta" : this.user.lokasi === "jakarta" ? "jakarta_pontianak" : "declaring";
      this.form = { id: null, tanggal: today(), arah, jenis: "keluar", kategori: "", keterangan: "", nominal: 0 };
    }
  }
};
</script>
